import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../button/button';
import { PaginationNumber } from './components/pagination-number';
import { ELLIPSIS, getPaginationStringsToDisplay } from './services/get-pagination-strings-to-display';
import styles from './pagination.module.scss';

type Props = {
  currentPage: number;
  lastPage: number;
  setPage: (page: number) => void;
};

export const Pagination: React.FC<Props> = ({ currentPage, lastPage, setPage }) => {
  const { t } = useTranslation();
  const canNavigateForward = currentPage < lastPage;
  const canNavigateBackward = currentPage > 1;

  const paginationStrings = getPaginationStringsToDisplay({ currentPage, lastPage });

  return (
    <div className={styles.root}>
      <Button
        className={styles.hideOnMobile}
        disabled={!canNavigateBackward}
        icon="arrow-left"
        iconPosition="left"
        variant="secondary"
        onClick={() => setPage(currentPage - 1)}
      >
        {t('pagination.back')}
      </Button>
      <div className={styles.numberContainer}>
        {paginationStrings.map((string, index) => (
          <PaginationNumber
            key={`${string}_${index}`}
            active={currentPage.toString() === string}
            onClick={
              string !== ELLIPSIS
                ? () => {
                    setPage(parseInt(string, 10));
                  }
                : undefined
            }
          >
            {string}
          </PaginationNumber>
        ))}
      </div>
      <Button
        className={styles.mobileOnly}
        disabled={!canNavigateBackward}
        icon="arrow-left"
        iconPosition="left"
        variant="secondary"
        onClick={() => setPage(currentPage - 1)}
      >
        {t('pagination.back')}
      </Button>
      <Button
        disabled={!canNavigateForward}
        icon="arrow-right"
        iconPosition="right"
        variant="secondary"
        onClick={() => setPage(currentPage + 1)}
      >
        {t('pagination.continue')}
      </Button>
    </div>
  );
};
